import React, { useEffect, useState, useContext, useMemo } from "react";
import { Container, Row, Col, Form, Table, Button } from "react-bootstrap";
import { apiGet } from "../utils/apiFetch";
import apiPath from "../utils/apiPath";
import obj from "../utils/constants";
import helpers from "../utils/helpers";
import AuthContext from "../context/AuthContext";
import { get, isEmpty } from "lodash";
import { useParams } from "react-router-dom";
import ReactPaginate from "react-paginate";
const MatchOddsList = () => {
  const params = useParams();
  const [result, setResult] = useState([]);
  const [team, setTeam] = useState("");
  const [detail, setDetail] = useState({});
  const [updated, setUpdated] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [filter, setFilter] = useState({
    page: 1,
    limit: 50,
    marketId: params?.marketId,
  });
  const getData = async (object, filter, team) => {
    const { status, data } = await apiGet(apiPath.matchOddsRisk, filter);
    if (status === 200) {
      if (data.success) {
        let result = data?.results?.data[0]?.dataLog;
        setResult(result);
        setPageCount(Math.ceil(data?.results?.totalPages) || 0);
        if (!isEmpty(team)) {
          setUpdated(
            result?.map((res) => {
              return {
                ...res,
                runners: res?.runners?.find((item) => {
                  return item?.selectionId == team;
                }),
              };
            })
          );
        } else if (object?.jsonData?.length > 0) {
          setUpdated(
            result?.map((res) => {
              return {
                ...res,
                runners: res?.runners?.find((item) => {
                  return item?.selectionId == object?.jsonData[0]?.SelectionId;
                }),
              };
            })
          );
        }
      }
    }
  };

  useEffect(() => {
    getDetail();
  }, []);

  const getDetail = async () => {
    const { status, data: response_users } = await apiGet(apiPath.matchDetail, {
      eventId: params?.eventId,
    });
    if (status === 200) {
      if (response_users.success) {
        setDetail(response_users.results);
        getData(response_users.results, filter, team);
      }
    }
  };
  const handel = (id) => {
    setTeam(id);
    setUpdated(
      result?.map((res) => {
        return {
          ...res,
          runners: res?.runners?.find((item) => {
            return item?.selectionId == id;
          }),
        };
      })
    );
  };

  const handlePageClick = (event) => {
    setFilter((prevState) => {
      return {
        ...prevState,
        page: event.selected + 1,
      };
    });
    getData(detail, { ...filter, page: event.selected + 1 }, team);
  };

  return (
    <div>
      {" "}
      <div className="user_data_div p-1">
        <section className="main-inner-outer py-3">
          <Container fluid>
            <div className="inner-wrapper">
              <div className="common-container">
                {" "}
                <Form className="p-3" style={{ background: "#f3f4f6" }}>
                  <h4>{detail?.eventName}</h4>
                  <div className="bet_outer">
                    <div className="bet-sec p-1">
                      <Form.Select
                        className="small_select"
                        value={team}
                        onChange={(e) => handel(e.target.value)}
                        aria-label="Default select example"
                      >
                        {detail?.jsonData?.map((res) => {
                          return (
                            <option
                              value={res?.SelectionId}
                              className={res?.RunnerName}
                            >
                              {res?.RunnerName}
                            </option>
                          );
                        })}
                      </Form.Select>
                    </div>
                  </div>
                </Form>
                <div className="account-table account-tabel-style batting-table">
                  <div className="responsive">
                    <Table>
                      <thead>
                        <tr>
                          <th scope="col">Time</th>

                          <th scope="col">Odds </th>
                        </tr>
                      </thead>
                      <tbody>
                        {updated?.map((res) => {
                          return (
                            <tr>
                              <td>{helpers.timeFormat(res?.timestamp)} </td>
                              <td>
                                <div className="d-flex align-items-center">
                                  <div
                                    className="d-flex"
                                    style={{ width: "30%" }}
                                  >
                                    {res?.runners?.layOdds?.map((res) => {
                                      return (
                                        <div
                                          style={{ width: "100%" }}
                                          className="fw-normal text-center bet-name lay rounded-0 p-1"
                                        >
                                          <strong className="d-block">
                                            {res?.price}
                                          </strong>
                                          {res?.size}
                                        </div>
                                      );
                                    })}
                                  </div>
                                  <div
                                    className="d-flex"
                                    style={{ width: "30%" }}
                                  >
                                    {res?.runners?.backOdds?.map((res) => {
                                      return (
                                        <div
                                          style={{ width: "100%" }}
                                          className="fw-normal text-center bet-name back rounded-0 p-1"
                                        >
                                          <strong className="d-block">
                                            {res?.price}
                                          </strong>
                                          {res?.size}
                                        </div>
                                      );
                                    })}
                                  </div>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                  <div className="bottom-pagination">
                    <ReactPaginate
                      breakLabel="..."
                      nextLabel="Next"
                      onPageChange={handlePageClick}
                      pageRangeDisplayed={10}
                      pageCount={pageCount}
                      previousLabel="Prev"
                      renderOnZeroPageCount={null}
                      activeClassName="p-0"
                      activeLinkClassName="pagintion-li"
                    />
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </section>
      </div>
    </div>
  );
};

export default MatchOddsList;
